import React from "react";

export default class Boolingteam extends React.Component {
  constructor() {
    super();
    this.state = {
      team: {},
      players: {}
    };
  }
  componentDidMount() {
    this.setState({
      team: this.props.team,
      players: this.props.team.players
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      team: nextProps.team,
      players: this.props.team.players
    });
  }

  render() {
    let this_over = this.props.this_over;
    // console.log(this.state.players.name.length - 1);
    let player = this.state.players;
    let team = this.state.team;
    let old = false;
    return (
      <div>
        {old ? (
          <div className="widget_body_column_new ">
            <div className="flex_col alignstart">
              <h4 className="blueEboldnew16 text_green">{team.name}</h4>
              <h6 className="bluesemi9 text_green mt2">{team.action}</h6>
            </div>
            <div className="flex_col aligncenter">
              {Object.keys(player).length > 0
                ? Object.keys(player).map(ind => {
                    return (
                      <h4 key={Math.random()} className="whitesemi16">
                        {player[ind]["name"]}
                      </h4>
                    );
                  })
                : ""}
            </div>
            <div className="flex_col alignright">
              {Object.keys(player).length > 0
                ? Object.keys(player).map(ind => {
                    return (
                      <h4
                        key={Math.random()}
                        className="blueblacknew16 text_green"
                      >
                        {player[ind]["score"]}
                      </h4>
                    );
                  })
                : ""}
            </div>
          </div>
        ) : (
          <div>
            <div className="widget_body_column_new ">
              <div className="flex_col alignstart">
                <h4 className="blueEboldnew16 text_green">{team.name}</h4>
                <h6 className="bluesemi9 text_green mt4">{team.action}</h6>
              </div>
              <div className="flex_col aligncenter">
                {Object.keys(player).length > 0
                  ? Object.keys(player).map((ind, key) => {
                      if (key == 0) {
                        return (
                          <h4 key={Math.random()} className="whitesemi16">
                            {player[ind]["name"]}
                          </h4>
                        );
                      }
                    })
                  : ""}
                {this_over ? <h5 className="thisover">This over</h5> : ""}
              </div>
              <div className="flex_col alignright">
                {Object.keys(player).length > 0
                  ? Object.keys(player).map((ind, key) => {
                      console.log(key);
                      if (key == 0) {
                        return (
                          <h4
                            key={Math.random()}
                            className="blueblacknew16 text_green"
                          >
                            {player[ind]["score"]}
                          </h4>
                        );
                      }
                    })
                  : ""}

                {this_over ? (
                  <h5 className="thisover_details text_green mt2">
                    {this_over}
                  </h5>
                ) : (
                  ""
                )}
              </div>
            </div>
            {/* <div className="thisovrsection">
            <h5 className="bluesemi9 alignstart">Batting</h5>
          <h5 className="thisover">this over</h5>
          <h5 className="thisover_details">5 balls 12 runs</h5>
          </div> */}
          </div>
        )}
      </div>
    );
  }
}
